import React from "react";

import DatePicker from "react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";

function DatePickerComponent(props) {
  const customInput = ({ ref }) => {
    return (
      <input
        readOnly
        ref={ref} // necessary
        placeholder={props.placeholder ? props.placeholder :"Enter your child's date of birth"}
        data-arg="dob"
        required={true}
        value={
          props.value
            ? `${props.value.day}/${props.value.month}/${props.value.year}`
            : ""
        }
        style={{
          textAlign: "left",
          fontSize: "1rem",
          width: "100%",
          // color: "#999",
        }}
        className="custom-datepicker" // a styling class
      />
    );
  };
  return (
      <DatePicker
        value={props.value}
        onChange={props.onChange}
        shouldHighlightWeekends={true}
        renderInput={customInput}
        colorPrimary="#ff0033"
        colorPrimaryLight="#3ee9f7"
        wrapperClassName="date-picker"
        width="100%"
      />
  );
}

export default DatePickerComponent;



// WEBPACK FOOTER //
// ./src/components/DatePicker/DatePickerComponent.jsx